import React from 'react';
import { Shield, Award, Users, TrendingUp, Clock, CheckCircle } from 'lucide-react';
import './AboutUs.css';

const AboutUs = () => {
  const values = [
    {
      icon: <Shield size={40} />,
      title: 'Integrity',
      description: 'We maintain the highest ethical standards in all our interactions and provide honest, transparent advice to our clients.'
    },
    {
      icon: <Award size={40} />,
      title: 'Excellence',
      description: 'We are committed to delivering exceptional service quality and achieving the best possible outcomes for every client.'
    },
    {
      icon: <Users size={40} />,
      title: 'Client-Focused',
      description: 'Your success is our success. We tailor our services to meet your unique needs and provide personalized support throughout your journey.'
    }
  ];

  const stats = [
    { number: '10,000+', label: 'Clients Served' },
    { number: '98%', label: 'Success Rate' },
    { number: '15+', label: 'Years Experience' },
    { number: '24/7', label: 'Support Available' }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1 className="page-title">About Unity Trademark</h1>
          <p className="page-subtitle">
            Your trusted partner in protecting and growing your brand through comprehensive 
            trademark, copyright, and business formation services.
          </p>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="section">
        <div className="container">
          <div className="two-column">
            <div className="column-content">
              <h2 className="section-title-left">Our Story</h2>
              <p className="text-paragraph">
                Unity Trademark was founded with a simple mission: make intellectual property protection 
                accessible and affordable for businesses of all sizes. We recognized that many entrepreneurs 
                and small business owners were underserved by traditional legal services, facing high costs 
                and complex processes when trying to protect their brands.
              </p>
              <p className="text-paragraph">
                Today, we've helped thousands of businesses secure their trademarks, copyrights, and 
                legal foundations. Our team of experienced attorneys and specialists combines legal 
                expertise with modern technology to provide efficient, cost-effective solutions without 
                compromising on quality or service.
              </p>
            </div>
            <div className="column-image">
              <img 
                src="https://images.unsplash.com/photo-1758518731457-5ef826b75b3b" 
                alt="Our team" 
                className="story-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Our Values Section */}
      <section className="section section-light">
        <div className="container">
          <h2 className="section-title">Our Core Values</h2>
          <p className="section-subtitle">
            The principles that guide everything we do and shape how we serve our clients.
          </p>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">{value.icon}</div>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="section stats-banner">
        <div className="container">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-item">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">Why Businesses Choose Us</h2>
          <div className="features-list">
            <div className="feature-item">
              <CheckCircle className="feature-check" size={24} />
              <div>
                <h3>Experienced Legal Team</h3>
                <p>Our attorneys and specialists bring decades of combined experience in intellectual property law.</p>
              </div>
            </div>
            <div className="feature-item">
              <CheckCircle className="feature-check" size={24} />
              <div>
                <h3>Transparent Pricing</h3>
                <p>No hidden fees or surprise charges. You know exactly what you're paying upfront.</p>
              </div>
            </div>
            <div className="feature-item">
              <CheckCircle className="feature-check" size={24} />
              <div>
                <h3>Fast Turnaround</h3>
                <p>We process applications quickly and offer expedited services when you need them.</p>
              </div>
            </div>
            <div className="feature-item">
              <CheckCircle className="feature-check" size={24} />
              <div>
                <h3>24/7 Support</h3>
                <p>Our dedicated support team is available around the clock to answer your questions.</p>
              </div>
            </div>
            <div className="feature-item">
              <CheckCircle className="feature-check" size={24} />
              <div>
                <h3>Comprehensive Services</h3>
                <p>From trademark registration to company formation, we handle all your legal needs.</p>
              </div>
            </div>
            <div className="feature-item">
              <CheckCircle className="feature-check" size={24} />
              <div>
                <h3>Success Guarantee</h3>
                <p>We stand behind our work with satisfaction guarantees and will address any issues that arise.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;